const supplier = {
    getlist: 'supplier/getlist',
    add: 'supplier/add',
    update: 'supplier/update',
    remove: 'supplier/remove',
    get: 'supplier/get',
    getall: 'supplier/getall',
    clearcache: 'supplier/clear-cache',
}
export default supplier
